export const PATH={
    DEFAULT:"/",
    LOGIN:'/login',
    BALANCE_SHEET:"/balance-sheet",
    CASHFLOW_SHEET:"/cashflow-sheet",
    BALANCE_GENERATE:"/balance-generate",
    CASHFLOW_GENERATE:"/cashflow-generate",
    CONFIGURE:'/configure'
}